import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Allow selectedChildModule to be either a number or null
const initialState:any = {
   deduplicationWorkflowData:[],
   goldenrecordData:[],
   rowData:[],
   approvalData:{},
   selectedModule:null,
   payload:null,
   status:"pending"
   

};

const deduplicationWorkflowData = createSlice({
    name: 'deDuplication',
    initialState,
    reducers: {
        setWorkflowData: (state, action: PayloadAction<any>) => {
            state.deduplicationWorkflowData = action.payload;
        },
        seGoldenRecordData: (state, action: PayloadAction<any>) => {
            state.goldenrecordData = action.payload;
        },
        setRowdatamerge: (state, action: PayloadAction<any>) => {
            state.rowData = action.payload;
        },
        setApprovalData: (state, action: PayloadAction<any>) => {
            state.approvalData = action.payload;
        },
        setSelectedModulemerge: (state, action: PayloadAction<any>) => {
            state.selectedModule = action.payload;
        },
        setStatusmerge: (state, action: PayloadAction<any>) => {
            state.status = action.payload;
        },
        setpayload: (state, action: PayloadAction<any>) => {
            state.payload = action.payload;
        },
        resetDataMerge: () => initialState, // Reset state to initialState

       
    },
});

export const {setWorkflowData ,seGoldenRecordData,setRowdatamerge,setApprovalData,setSelectedModulemerge,resetDataMerge,setStatusmerge,setpayload} = deduplicationWorkflowData.actions;

export default deduplicationWorkflowData.reducer;
